import { Box, Button, Modal, Typography, Paper, CircularProgress, Alert, FormControl, Stack, TextField, Autocomplete } from "@mui/material";
import { useGetEmployeeListNewQuery } from "../../../services/invoices/InvoiceApiSlice";
import { useEffect, useState } from "react";

export default function GRNActionModal({ open, onClose, billAmount, handleInvoiceSubmit, totalSelectedAmount, modalAction, isFI, selectedEmp }) {
  const [isSecondStep, setIsSecondStep] = useState<boolean>(false);
  const [remarks, setRemarks] = useState<string>("");
  const [selectedApproverId, setSelectedApproverId] = useState<string>(null);
  const [selectedApproverDetails, setSelectedApproverDetails] = useState<any>(null);
  const _billAmount = +billAmount?.replaceAll(",", "");
  const upperAmount = _billAmount + 500;
  const lowerAmount = _billAmount - 50;

  const handleSubmit = () => {
    if (modalAction === "assign-approver" && !isSecondStep) {
      setIsSecondStep(true);
    } else if (modalAction === "assign-approver") {
      handleInvoiceSubmit(modalAction, remarks, selectedApproverId, selectedApproverDetails);
    } else {
      resetForm();
      handleInvoiceSubmit();
      onClose();
    }
  };

  useEffect(() => {
    setIsSecondStep(isFI && modalAction === "assign-approver");
  }, [isFI, modalAction]);

  const resetForm = () => {
    setRemarks("");
    setIsSecondStep(false);
    setSelectedApproverId(null);
    setSelectedApproverDetails(null);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const {
    data: employeeData,
    isLoading: isEmployeeDataLoading,
    isError: isEmployeeDataError,
    error: employeeDataError,
    refetch: employeeDataRefetch,
  } = useGetEmployeeListNewQuery(null, {
    skip: modalAction !== "assign-approver",
  });

  const employeeOptions =
    employeeData?.d?.results?.map((emp) => ({
      label: `${emp?.ename} - ${emp?.pernr} - ${emp?.position_txt} - ${emp?.persa_txt} - ${emp?.btrtl_txt}`,
      value: emp?.pernr,
      ename: emp?.ename,
      username: emp?.username,
    })) || [];

  const selectedOption = employeeOptions.find((option) => option.value === selectedApproverId) || null;

  return (
    <Modal open={open} onClose={handleClose}>
      <Paper
        elevation={3}
        sx={{
          maxWidth: 800,
          borderRadius: 2,
          p: 3,
          mx: "auto",
          mt: "10%",
        }}
      >
        {!isSecondStep ? (
          <>
            <Typography variant="h6" gutterBottom>
              Confirm {modalAction === "assign-approver" ? "Forward" : "Park"} Invoice
            </Typography>

            <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
              Are you sure you want to {modalAction === "assign-approver" ? "Forward" : "Park"} the {isFI ? "invoice" : "selected invoice items?"}
            </Typography>
            {/* {isFI && (
              <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
                Employee Name : <b>{selectedEmp?.empName}</b> and Code : <b>{selectedEmp?.empCode}</b>
              </Typography>
            )} */}

            {billAmount !== undefined && !isFI && (
              <>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  Selected GRN Amount: ₹{totalSelectedAmount.toFixed(2)}
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  Invoice Amount: ₹{billAmount}
                </Typography>
                {/* {!isFI && !(totalSelectedAmount.toFixed(2) <= +billAmount?.replaceAll(",", "") + 50) && ( */}
                {!isFI && !(totalSelectedAmount.toFixed(2) >= lowerAmount && totalSelectedAmount.toFixed(2) <= upperAmount) && (
                  <Typography variant="body2" sx={{ mb: 2 }} style={{ color: "red" }}>
                    {/* kindly allow below 500 and above 50 while making park documents form bts to SAP. */}
                    <b>Parking Blocked - Amount Mismatch</b><br />
                    GRN amount must be within ₹50 below to ₹500 above the Invoice amount.<br />
                    <i>Example: For Invoice ₹1,00,000, GRN must be between ₹99,950 and ₹1,00,500. Anything outside (even ₹0.01) is not allowed.</i>
                  </Typography>
                )}
              </>
            )}


            <Box display="flex" gap={2} justifyContent="flex-end">
              <Button variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="contained" color="primary" onClick={handleSubmit} disabled={!isFI && !(totalSelectedAmount.toFixed(2) >= lowerAmount && totalSelectedAmount.toFixed(2) <= upperAmount)}>
                Confirm
              </Button>
            </Box>
          </>
        ) : (
          <>
            {isEmployeeDataLoading ? (
              <CircularProgress size={24} sx={{ alignSelf: "center" }} />
            ) : isEmployeeDataError ? (
              <Alert
                severity="error"
                action={
                  <Button color="inherit" size="small" onClick={employeeDataRefetch}>
                    Retry
                  </Button>
                }
              >
                Failed to load employees
              </Alert>
            ) : (
              <>
                <Stack direction="column" spacing={2}>
                  <Typography variant="h5" component="h5">
                    Assign approver
                  </Typography>

                  <>
                    {isEmployeeDataLoading ? (
                      <CircularProgress size={24} sx={{ alignSelf: "center" }} />
                    ) : isEmployeeDataError ? (
                      <Alert
                        severity="error"
                        action={
                          <Button color="inherit" size="small" onClick={employeeDataRefetch}>
                            Retry
                          </Button>
                        }
                      >
                        Failed to load employees
                      </Alert>
                    ) : (
                      <FormControl fullWidth>
                        <Autocomplete
                          options={employeeOptions}
                          value={selectedOption}
                          onChange={(event, newValue) => {
                            setSelectedApproverId(newValue ? newValue.value : "");
                            setSelectedApproverDetails(newValue || null);
                          }}
                          getOptionLabel={(option) => option.label}
                          isOptionEqualToValue={(option, value) => option.value === value.value}
                          renderInput={(params) => <TextField {...params} label="Whom do you want to assign it to?" variant="outlined" fullWidth />}
                          filterOptions={(options, { inputValue }) => {
                            return options.filter((option) => option.label.toLowerCase().includes(inputValue.toLowerCase()));
                          }}
                          noOptionsText="No employees found"
                          clearOnEscape
                          selectOnFocus
                          handleHomeEndKeys
                        />
                      </FormControl>
                    )}
                  </>

                  <TextField fullWidth multiline minRows={3} label="Remarks" variant="outlined" value={remarks} onChange={(e) => setRemarks(e.target.value)} />
                </Stack>

                <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
                  <Button variant="outlined" size="small" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={(modalAction === "assign-approver" && (!remarks.trim() || !selectedApproverId || isEmployeeDataLoading || isEmployeeDataError)) || !remarks.trim()}
                  >
                    FORWARD
                  </Button>
                </Stack>
              </>
            )}
          </>
        )}
      </Paper>
    </Modal>
  );
}
